export default __webpack_public_path__ + "static/media/2_star_giftcard_inviter.9f1f24c4.svg";